import React from 'react'
import PropTypes from 'prop-types'
import { Container, Row } from 'shards-react'

const MainFooter = ({ contained }) => (
    <footer className="main-footer d-flex p-2 px-3 bg-white border-top">
        <Container fluid={contained}>
            <Row>
                <span className="copyright ml-auto my-auto mr-2">
                    {/*{copyright} {process.env.REACT_APP_VERSION}*/}
                </span>
            </Row>
        </Container>
    </footer>
)

MainFooter.propTypes = {
    /**
     * Whether the content is contained, or not.
     */
    contained: PropTypes.bool,
    /**
     * The menu items array.
     */
    menuItems: PropTypes.array,
    /**
     * The copyright info.
     */
    copyright: PropTypes.string,
}
MainFooter.defaultProps = {
    contained: false,
    menuItems: [
        {
            title: 'Home',
            to: '#',
        },
        {
            title: 'Services',
            to: '#',
        },
        {
            title: 'About',
            to: '#',
        },
        {
            title: 'Products',
            to: '#',
        },
        {
            title: 'Blog',
            to: '#',
        },
    ],
}

export default MainFooter
